import * as Dashboard_en from './Dashboard.en.js';
import * as Dashboard_es from './Dashboard.es.js';

const DashboardTuple = [
  { type: 'Dashboard', language: 'en', object: Dashboard_en.default },
  { type: 'Dashboard', language: 'es', object: Dashboard_es.default },
];

export default DashboardTuple;
